import React from "react";
import { useApp } from "../../context/AppContext";
import { Reveal, Kicker } from "../motion";
import advantagesLogo from "../../assets/brand/logo_3d_advantages_transparent.webp";

export function Advantages() {
  const { c } = useApp();
  const a = c.advantages;

  return (
    <section data-testid="advantages-section" className="topo relative bg-[#f5f7fa] py-24 md:py-32">
      <div className="mx-auto grid max-w-[1240px] gap-12 px-5 md:px-8 lg:grid-cols-[0.9fr_1.6fr] lg:gap-20">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <Reveal>
            <Kicker>{a.kicker}</Kicker>
            <h2 className="mt-5 font-display text-4xl font-bold tracking-tight text-[#0a1a2e] sm:text-5xl">
              {a.title}
            </h2>
            <img
              src={advantagesLogo}
              alt="Batys Finance"
              loading="lazy"
              decoding="async"
              className="mt-10 w-64 max-w-full object-contain object-left md:w-80"
            />
          </Reveal>
        </div>

        <div className="flex flex-col">
          {a.items.map((item, i) => (
            <Reveal
              key={item.n}
              delay={i * 0.05}
              className="group grid grid-cols-[auto_1fr] items-start gap-6 border-t border-[#002355]/12 py-8 first:border-t-0 md:gap-10"
            >
              <span className="font-display text-3xl font-extrabold tracking-tight text-[#002355]/25 transition-colors duration-300 group-hover:text-[#e8a93d] md:text-4xl">
                {item.n}
              </span>
              <div>
                <h3 className="font-display text-2xl font-bold tracking-tight text-[#0a1a2e] md:text-3xl">
                  {item.title}
                </h3>
                <p className="mt-2 max-w-lg text-base leading-relaxed text-[#3e516a]">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
